import { Component, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Base } from '../../base';
import { MatDialog } from '@angular/material/dialog';
import { ValidationService } from '../../../../utils/util.validation';
import html2canvas from 'html2canvas';
import { CarnetRespondeModel } from '../../../../models/carnet';
import { jsPDF } from "jspdf";

@Component({
  selector: 'app-dialog-carnet-send',
  templateUrl: './dialog-carnet-send.component.html',
  styleUrls: ['./dialog-carnet-send.component.css']
})
export class DialogCarnetSendComponent extends Base {

  @ViewChild('cellphoneInput') cellphoneInput!: ElementRef;
  @ViewChild('emailInput') emailInput!: ElementRef;
  @Output() generateEvent = new EventEmitter<number>();
  frmOptions: FormGroup;
  optionSelected: any = 0;
  isLocked: boolean = true;
  showPreview: boolean = false;
  dataCarnetPreview: CarnetRespondeModel;
  isONCA:boolean = false;
  isDEB:boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogCarnetSendComponent>,
    private matDialog: MatDialog,
    private utilsApp: ValidationService,
    private fb: FormBuilder
  ) {
    super();
    this.dataCarnetPreview = data.dataBeneficiaries[0];    
    this.frmOptions = this.fb.group({
      selectedOption: '',
      cellphone: [{ value: this.dataCarnetPreview.Telefono, disabled: this.isLocked }, [Validators.required]],
      email: [{ value: this.dataCarnetPreview.Email, disabled: this.isLocked }, [Validators.required, this.utilsApp.emailValidation()]],
    });
    this.showPreview = data.showPreview;
    this.dataCarnetPreview.Plan == 'ONCA'? this.isONCA = true : this.isONCA = false;
    this.dataCarnetPreview.Plan == 'DEB'? this.isDEB = true : this.isDEB = false;
    this.dataCarnetPreview.identificacion = this.dataCarnetPreview.identificacion.replace(/.*- /, "");
    this.dataCarnetPreview.VigenciaPlan = this.dataCarnetPreview.VigenciaPlan.replace(/-/g, '');
    this.dataCarnetPreview.FechaNacimiento = this.dataCarnetPreview.FechaNacimiento.replace(/-/g, '');    
  }

  onSelectionChange(event: any) {
    const selectedOption = this.frmOptions.value.selectedOption;
    if (selectedOption === '1') {
      this.cellphoneInput.nativeElement.focus();
    } else if (selectedOption === '2') {
      this.emailInput.nativeElement.focus();
    }    
  }

  modifyData() {
    this.isLocked = !this.isLocked;
    if (this.isLocked) {
      this.frmOptions.get('cellphone')?.disable();
      this.frmOptions.get('email')?.disable();
      this.frmOptions.get('cellphone')?.setValue(this.dataCarnetPreview.Telefono);
      this.frmOptions.get('email')?.setValue(this.dataCarnetPreview.Email);
    } else {
      this.frmOptions.get('cellphone')?.enable();
      this.frmOptions.get('email')?.enable();
      // Focusing the input based on selected option
      if (this.frmOptions.value.selectedOption === '1') {
        this.cellphoneInput.nativeElement.focus();
      } else if (this.frmOptions.value.selectedOption === '2') {
        this.emailInput.nativeElement.focus();
      }
    }
  }

  sendData() {
    if (!this.frmOptions.valid) {
      this.showMessageDialog("Error", "Debe seleccionar una opción antes de enviar.", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
      return;
    }
    switch (this.frmOptions.value.selectedOption) {
      case '1': // whatsapp
        this.generatePDF()
        // Emit event to the parent component
        this.generateEvent.emit(this.frmOptions.value.selectedOption);
        const telefono = this.frmOptions.get('cellphone')?.value;
        const url = 'https://wa.me/+57' + telefono; // abrir whatsapp
        window.open(url, '_blank', 'noopener,noreferrer');
        this.close();
        break;
      case '2': //email
        this.generatePDF()
        this.showMessageDialog("Exito", "Se envio correctamente", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
        this.close();
        break;
      default:
        this.showMessageDialog("Error", "Debe seleccionar una opción válida.", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
    }
  }

  generatePDF(): void {    
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const baseImage = new Image();
    baseImage.src = this.dataCarnetPreview.imagen;
    baseImage.onload = () => {
      canvas.width = baseImage.width;
      canvas.height = baseImage.height;
      if (context) {
        //nombre del colectivo del servicio
        let nombreColectivo = this.dataCarnetPreview.nombreColectivo;
        context.drawImage(baseImage, 0, 0);
        if (this.dataCarnetPreview.Plan == "ONCA") {
          context.font = '30px MainFontBold';
          context.fillStyle = 'black';
          context.fillText(this.dataCarnetPreview.AsesorGestion.toString(), 80, 400); //codigo asesor
          // Dibuja el texto de nombreColectivo con saltos de línea
          const lineHeight = 25; // Ajusta el alto de línea según sea necesario
          this.drawTextWithLineBreaks(context, this.insertLineBreaks(nombreColectivo, 48), 80, 425, lineHeight);
          context.fillText(this.dataCarnetPreview.nombre, 80, 490)
        } else {
          context.font = '35px MainFontBold';
          context.fillStyle = 'black';
          context.fillText(this.dataCarnetPreview.AsesorGestion.toString(), 80, 450); //codigo asesor
          context.fillText(this.dataCarnetPreview.nombre, 80, 480)
        }
        context.fillText(this.dataCarnetPreview.tipoPlan + " " + this.dataCarnetPreview.cobertura + " " + this.dataCarnetPreview.Plan + " " + this.dataCarnetPreview.franquicia, 180, 520); //plan
        context.fillText(this.dataCarnetPreview.identificacion.replace(/.*- /, ""), 800, 560); //identificación
        context.fillText(this.dataCarnetPreview.ContratoAfiliado + "  " + this.dataCarnetPreview.NumeroUsuario + "  " + this.dataCarnetPreview.numeroConsecutivo + "  " + this.dataCarnetPreview.Linea, 80, 560) //credencial
        context.fillText(this.dataCarnetPreview.FechaNacimiento.replace(/-/g, ''), 420, 625); //FECHA NACIMIENTO
        context.fillText(this.dataCarnetPreview.VigenciaPlan.replace(/-/g, ''), 780, 625); //FECHA inicio
        // Crear el PDF con el tamaño de la imagen
        let editedImage = canvas.toDataURL('image/jpeg');
        const pdfWidth = baseImage.width;
        const pdfHeight = baseImage.height;
        const doc = new jsPDF({
          orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
          unit: 'px',
          format: [pdfWidth, pdfHeight]
        });
        doc.addImage(editedImage, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        doc.save('carnet' + '_' + this.dataCarnetPreview.nombre.trim().replace(/\s+/g, "_") + '_'+ this.dataCarnetPreview.identificacion.replace(/.*- /, "") + '_' + this.dataCarnetPreview.Plan + '.pdf');

      };
    }
  }

  drawTextWithLineBreaks(context: CanvasRenderingContext2D, text: string, x: number, y: number, lineHeight: number) {
    const lines = text.split('\n');
    lines.forEach((line, index) => {
      context.fillText(line, x, y + (index * lineHeight));
    });
  }
  insertLineBreaks(text: string, maxLineLength: number): string {
    const regex = new RegExp(`(.{1,${maxLineLength}})`, 'g');
    return text.match(regex)?.join('\n') || text;
  }

  validatePhone(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  close() {
    this.dialogRef.close();
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmOptions.controls;
  }
}